import { useEffect } from 'react';
import '../../../css/modal.css'
import { useDynamicStyle } from '../../../hooks/useDynamicStyle';

const MonitoringMsgCmt_layer = ({isModalOpen, modalClose, msgCmt}) => {
    
    // esc 키 누르면 모달 닫히는 기능
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === "Escape") modalClose();
        };
    
        // 이벤트 리스너 등록
        document.addEventListener("keydown", handleEscape);
    
        // 컴포넌트가 언마운트될 때 이벤트 리스너 제거
        return () => {
            document.removeEventListener("keydown", handleEscape);
        };
    }, [modalClose]);

    const { lightBackColor, borderColorGray } = useDynamicStyle();

    return (
        <>
        {isModalOpen && 
            <div className='layer_container'>
                <div className='layer_wrapper' style={{maxWidth: '50rem'}}>
                    <div className='modal_title_box'>
                        <h4>정보관리 요청 내역 댓글 확인</h4>
                    </div>
                    <hr/>
                    <div className='data_grid_container'>
                        <hr className={`border-t-2 mr-1-1 ${borderColorGray}`} />
                        <div className='data_list_table td_wrap'>
                            <table>
                                <colgroup>
                                    <col width='10%'/>
                                    <col width='20%'/>
                                    <col width='50%'/>
                                    <col width='20%'/>
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>작성자</th>
                                        <th>소속기관</th>
                                        <th>내용</th>
                                        <th>등록일시</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {msgCmt.map((item, idx) => {
                                        const gridColor = idx % 2 === 0 ? lightBackColor : '';
                                        return (
                                            <tr key={idx} className={`middle ${gridColor}`}>
                                                <td>{item.EVL_CMT_USR_NAM}</td>
                                                <td>{item.EMOGDESC}</td>
                                                <td>{item.EVL_CMT_COT}</td>
                                                <td>{item.EVL_CMT_RES_DTM}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <hr />
                    <div className='modal_btn_box justify-center'>
                        <div className='modal_btn bg_co_black cursor-pointer' onClick={modalClose}>닫기</div>
                    </div>
                </div>
            </div>
        }
        </>
    )
}

export default MonitoringMsgCmt_layer